/** Liaison poste ↔ client(s) commercial(aux). */
export interface LicenceBinding {
  customer_id: string;
  tenant_id: string;
  /** Présent en mode portefeuille Multi-entités. */
  cabinet_group_id?: string;
}

export function parseLicenceBinding(raw: string | null): LicenceBinding | null {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<LicenceBinding>;
    if (
      typeof parsed.customer_id === 'string' &&
      parsed.customer_id.length > 0 &&
      typeof parsed.tenant_id === 'string' &&
      parsed.tenant_id.length > 0
    ) {
      return {
        customer_id: parsed.customer_id,
        tenant_id: parsed.tenant_id,
        ...(typeof parsed.cabinet_group_id === 'string' && parsed.cabinet_group_id.length > 0
          ? { cabinet_group_id: parsed.cabinet_group_id }
          : {}),
      };
    }
    return null;
  } catch {
    return null;
  }
}

export function claimsMatchBinding(
  claims: { customer_id: string; tenant_id: string },
  binding: LicenceBinding,
): boolean {
  return claims.customer_id === binding.customer_id && claims.tenant_id === binding.tenant_id;
}
